import { Input } from 'antd';
import { axiosInstance } from '../../utils/axios';
import { useEffect, useState } from 'react';
import { useMessage } from '../../hooks/useMessage';
import { useTranslation } from 'react-i18next';
const { TextArea } = Input;

interface CommentFieldProps {
  ApiUrl: string;
  comment: string;
}

const CommentField = ({ ApiUrl, comment }: CommentFieldProps) => {
  const [commentValue, setCommentValue] = useState(comment);
  const { toast } = useMessage();
  const { t } = useTranslation([
    'screening/general',
    'screening/identification',
  ]);

  useEffect(() => {
    setCommentValue(comment);
  }, [comment]);

  const saveComment = () => {
    axiosInstance
      .patch(ApiUrl, {
        comment: commentValue,
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleError = (error: any) => {
    switch (error.response.data.message) {
      case 'No existing datachecker data found':
        toast.error(
          t('EM-CommentNotPossible', { ns: 'screening/identification' }),
        );
        break;
      default:
        toast.error(t('EM-General'));
    }
  };

  return (
    <div style={{ marginTop: '10px', marginBottom: '10px' }}>
      <label>{t('L-Comment')}</label>
      <TextArea
        value={commentValue}
        onBlur={saveComment}
        onChange={(e) => setCommentValue(e.target.value)}
        maxLength={2000}
      />
    </div>
  );
};

export default CommentField;
